/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react'
import { Card, CardContent, CardExtra } from '../../Shared/Card'
import { Icon, Statistic, StatisticLabel, StatisticValue } from 'semantic-ui-react'
import { Link } from 'react-router-dom-v5-compat'
import React from 'react'
import { CardLoadingPlaceholder } from '../../Shared/CardLoadingPlaceholder'
import { useUnavailableItemSummary } from '../../../Home/UnavailableItems/hooks'
import { formatISO, roundToNearestMinutes, startOfDay } from 'date-fns'
import { useTranslation } from 'react-i18next'
import { UltyMoney } from '@ulty/ulty-ui'
import useUser from '../../../Shared/UserProvider/useUser'


const UnavailableItemsSummaryCard = () => {
    const [t] = useTranslation()
    const {user} = useUser()
    const from = formatISO(startOfDay(new Date()))
    const to = formatISO(roundToNearestMinutes(new Date(), {nearestTo: 5, roundingMethod: 'floor'}))

    const {data: summary, isLoading} = useUnavailableItemSummary({
        from, to,
    })

    return (<Card>
        <CardContent
          css={css`
              display: grid;
              place-items: center;
              gap: .5rem;
              ${isLoading ? '' : 'grid-template-columns: 1fr 1fr;'}
              grid-template-areas: ${isLoading ? `'a'` : `
                'a a'
                'b c'
                `};
              width: 283px;
              height: 175px;
          `}
        >
            {isLoading ? (
              <CardLoadingPlaceholder
                css={css`
                    grid-area: a;
                `}
              />
            ) : (
              <>
                  <Statistic
                    css={css`
                        grid-area: a;
                        &.ui.statistic, &.ui.statistic + .ui.statistic {
                            margin: 0;
                        }
                    `}
                    size="small"
                  >
                      <StatisticValue>
                          {summary.totalMissedRevenue > 0 ? (<UltyMoney
                            readonly
                            inline
                            noMargin
                            amount={summary.totalMissedRevenue}
                            currencyCode={user.getCompanyCurrency()}
                            locale={user.getCompanyLocale()}
                          />) : '-'}
                      </StatisticValue>
                      <StatisticLabel>{t('unavailable_items.summary.total_revenue')}</StatisticLabel>
                  </Statistic>

                  <Statistic
                    css={css`
                        grid-area: b;
                        align-self: start;
                        font-size: 8pt;
                        &.ui.statistic, &.ui.statistic + .ui.statistic {
                            margin: 0;
                        }
                    `}
                    color="red"
                    size="mini"
                  >
                      <StatisticValue>
                          {summary.totalMissedRevenueUnavailable > 0 ? (<UltyMoney
                            readonly
                            inline
                            noMargin
                            amount={summary.totalMissedRevenueUnavailable}
                            currencyCode={user.getCompanyCurrency()}
                            locale={user.getCompanyLocale()}
                          />) : '-'}
                      </StatisticValue>
                      <StatisticLabel>{t('unavailable_items.summary.total_revenue_unavailable')}</StatisticLabel>
                  </Statistic>

                  <Statistic
                    css={css`
                        grid-area: c;
                        align-self: start;
                        font-size: 8pt;
                    `}
                    color="green"
                    size="mini"
                  >
                      <StatisticValue>
                          {summary.totalMissedRevenueSubstituted > 0 ? (<UltyMoney
                            readonly
                            inline
                            noMargin
                            amount={summary.totalMissedRevenueSubstituted}
                            currencyCode={user.getCompanyCurrency()}
                            locale={user.getCompanyLocale()}
                          />) : '-'}
                      </StatisticValue>
                      <StatisticLabel>{t('unavailable_items.summary.total_revenue_substituted')}</StatisticLabel>
                  </Statistic>
              </>
            )}
        </CardContent>
        <CardExtra>
            <Link
              to={{
                  pathname: '/analytics/unavailable-items',
              }}>
                Produits indisponibles
                <Icon name="arrow right"/>
            </Link>
        </CardExtra>
    </Card>)
}

export { UnavailableItemsSummaryCard }
